export function makeCustomerProducts(payload) {
  return payload.map((product) => {
    return makeCustomerProduct(product);
  });
}

export function makeCustomerProduct(payload) {
  let customerProduct = new CustomerProduct(payload.id, payload.username);
  customerProduct.currency = payload.currency;
  customerProduct.balance = payload.balance;
  customerProduct.productName = payload.productName;
  customerProduct.updatedAt = payload.updatedAt;

  return customerProduct;
}

class CustomerProduct {
  constructor(id, username) {
    this.id = +id;
    this.username = username;

    this.currency = '';
    this.balance = '';
    this.productName = '';
    this.updatedAt = '';
  }
}

// TODO: Don't export by default
export default CustomerProduct;



// WEBPACK FOOTER //
// ./client/app/shared/models/customer-product.model.js